import React from 'react'
import { logSessionInfo } from '../../../../../services/logger'
import troubleshootIcon from '../../../../../../assets/studentPreChecks/repeat_audio_issue_troubleshoot_shoot.svg'
import continueIcon from '../../../../../../assets/studentPreChecks/repeat_audio_issue_continue.svg'
import endSessionIcon from '../../../../../../assets/studentPreChecks/repeat_audio_issue_end_session.svg'
import './RepeatAudioIssueInterstitialView.scss'

/**
 * Interstitial screen shown when mid-session audio issues are detected for a second time
 * (after the user has already been through the troubleshoot flow once and restarted).
 * Presents three options: troubleshoot again, allow the student to continue (suppressing
 * future troubleshoot triggers), or end the session entirely.
 *
 * End Session refreshes the page without URL params, which routes the user back to login.
 *
 * @param {Object} props - Component props.
 * @param {Function} props.onTroubleshoot - Resumes the normal troubleshoot flow.
 * @param {Function} props.onAllowContinue - Restarts session with audio issue suppression.
 */
export default function RepeatAudioIssueInterstitialView({ onTroubleshoot, onAllowContinue }) {
  const handleTroubleshoot = () => {
    logSessionInfo('teacherTroubleshoot_REPEAT_TROUBLESHOOT_CLICKED', {})
    onTroubleshoot()
  }

  const handleAllowContinue = () => {
    logSessionInfo('teacherTroubleshoot_REPEAT_ALLOW_CONTINUE_CLICKED', {})
    onAllowContinue()
  }

  const handleEndSession = () => {
    logSessionInfo('teacherTroubleshoot_REPEAT_END_SESSION_CLICKED', {})
    window.location.href = `${window.location.origin}${window.location.pathname}`;
  }

  return (
    <div className='repeat-audio-issue-interstitial'>
      <div className='repeat-audio-issue-interstitial__header'>
        Additional audio quality issues have been detected in this session.
      </div>

      <div className='repeat-audio-issue-interstitial__options'>
        <button
          className='repeat-audio-issue-interstitial__option'
          onClick={handleTroubleshoot}
        >
          <div className='repeat-audio-issue-interstitial__option-icon'>
            <img src={troubleshootIcon} alt='' />
          </div>
          <div className='repeat-audio-issue-interstitial__option-text'>
            <div className='repeat-audio-issue-interstitial__option-title'>
              Troubleshoot Issue
            </div>
            <div className='repeat-audio-issue-interstitial__option-desc'>
              Listen to student audio, test microphone, etc.
            </div>
          </div>
        </button>

        <button
          className='repeat-audio-issue-interstitial__option'
          onClick={handleAllowContinue}
        >
          <div className='repeat-audio-issue-interstitial__option-icon'>
            <img src={continueIcon} alt='' />
          </div>
          <div className='repeat-audio-issue-interstitial__option-text'>
            <div className='repeat-audio-issue-interstitial__option-title'>
              Allow Student to Continue Session
            </div>
            <div className='repeat-audio-issue-interstitial__option-desc'>
              Audio quality issues will be ignored for the remainder of the session.
            </div>
            <div className='repeat-audio-issue-interstitial__option-warning'>
              (Session data will likely be affected)
            </div>
          </div>
        </button>

        <button
          className='repeat-audio-issue-interstitial__option'
          onClick={handleEndSession}
        >
          <div className='repeat-audio-issue-interstitial__option-icon'>
            <img src={endSessionIcon} alt='' />
          </div>
          <div className='repeat-audio-issue-interstitial__option-text'>
            <div className='repeat-audio-issue-interstitial__option-title'>
              End Session
            </div>
            <div className='repeat-audio-issue-interstitial__option-desc'>
              Log student out of Amira for now. The assessment must be completed for additional content to become available.
            </div>
          </div>
        </button>
      </div>
    </div>
  )
}
